import React, { useState, useRef } from 'react';

function VerseHighlighter({ text, onHighlight, highlights = [] }) {
  const [selectedText, setSelectedText] = useState('');
  const [showHighlightMenu, setShowHighlightMenu] = useState(false);
  const [menuPosition, setMenuPosition] = useState({ x: 0, y: 0 });
  const textRef = useRef(null);

  const highlightColors = [
    { name: 'Yellow', color: '#fff3cd', class: 'highlight-yellow' },
    { name: 'Green', color: '#d4edda', class: 'highlight-green' },
    { name: 'Blue', color: '#cce5ff', class: 'highlight-blue' },
    { name: 'Pink', color: '#f8d7da', class: 'highlight-pink' },
    { name: 'Orange', color: '#fff4e5', class: 'highlight-orange' }
  ];

  const handleTextSelection = () => {
    const selection = window.getSelection();
    const selectedText = selection.toString().trim();

    if (selectedText && textRef.current.contains(selection.anchorNode)) {
      setSelectedText(selectedText);
      const range = selection.getRangeAt(0);
      const rect = range.getBoundingClientRect();
      setMenuPosition({
        x: rect.left + rect.width / 2,
        y: rect.top - 10
      });
      setShowHighlightMenu(true);
    } else {
      setShowHighlightMenu(false);
    }
  };

  const handleHighlight = (color) => {
    if (selectedText && onHighlight) {
      onHighlight(selectedText, color);
    }
    setShowHighlightMenu(false);
    window.getSelection().removeAllRanges();
  };

  const renderHighlightedText = () => {
    if (!highlights || highlights.length === 0) {
      return text;
    }

    let result = text;
    highlights.forEach(highlight => {
      const regex = new RegExp(`(${highlight.text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi');
      result = result.replace(regex, `<mark class="${highlight.color.class}">$1</mark>`);
    });

    return result;
  };

  return (
    <div className="verse-highlighter" onMouseUp={handleTextSelection}>
      <div
        ref={textRef}
        className="verse-text-content"
        dangerouslySetInnerHTML={{ __html: renderHighlightedText() }}
      />

      {showHighlightMenu && (
        <div
          className="highlight-menu"
          style={{
            position: 'fixed',
            left: menuPosition.x,
            top: menuPosition.y,
            transform: 'translate(-50%, -100%)',
            zIndex: 1000
          }}
        >
          <div className="highlight-colors">
            {highlightColors.map(color => (
              <button
                key={color.class}
                className="highlight-color-btn"
                style={{ backgroundColor: color.color }}
                onClick={() => handleHighlight(color)}
                title={`Highlight in ${color.name}`}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default VerseHighlighter;